import { Typography } from "@mui/material";

function bytesToGB_Binary(bytes) {
  const gigabytes = bytes / Math.pow(1024, 3); // 1024 * 1024 * 1024
  return gigabytes.toFixed(3);
}

function bytesToMegabytes(bytes) {
  // 1 MB (or rather MiB) is 1024 * 1024 bytes
  const size = bytes / (1024 * 1024);
  return size.toFixed(2);
}

export default function PlanType({ userData }) {
  return (
    <div>
      <Typography style={{ textAlign: "center" }} variant="h5" gutterBottom>
        {`Subscription Status: ${userData.stripe_status === "active" ? userData.stripe_plan_type : "Free Plan"}`}
      </Typography>
      <Typography style={{ textAlign: "center" }} variant="body1" gutterBottom>
        {`Storage Used: ${bytesToMegabytes(
          userData.storageUsed,
        )} MBs (${bytesToGB_Binary(userData.storageUsed)} GBs)`}
      </Typography>
      {userData.stripe_plan_type === "Standard" ? (
        <Typography
          style={{ textAlign: "center" }}
          variant="body1"
          gutterBottom
        >
          {`${((bytesToMegabytes(userData.storageUsed) / 50000) * 100).toFixed(
            2,
          )}% of 50 GBs (Standard storage limit)`}
        </Typography>
      ) : userData.stripe_plan_type === "Professional" ? (
        <Typography
          style={{ textAlign: "center" }}
          variant="body1"
          gutterBottom
        >
          {`${((bytesToMegabytes(userData.storageUsed) / 200000) * 100).toFixed(
            2,
          )}% of 200 GBs (Professional storage limit)`}
        </Typography>
      ) : (
        <Typography
          style={{ textAlign: "center" }}
          variant="body1"
          gutterBottom
        >
          {`${((bytesToMegabytes(userData.storageUsed) / 50) * 100).toFixed(
            2,
          )}% of 50 Megabytes free storage  limit`}
        </Typography>
      )}
    </div>
  );
}
